var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"render-name-of-question"},[_c('div',{staticClass:"name-of-question text-size-12",class:_vm.aligmentCss,staticStyle:{"overflow-wrap":"break-word"}},[_vm._v(" "+_vm._s(_vm.questionLable)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }